module.exports = __webpack_public_path__ + "static/media/payment-tick-monthly.fe30e4a3.svg";